import { useEffect, useState } from "react";
import api from "../../lib/api";
import { Users, Wallet, TrendingUp, Calendar } from "lucide-react";

const Card = ({ icon: Icon, label, value, sub }) => (
  <div className="card-academy rounded-lg p-5">
    <div className="flex items-center justify-between mb-3">
      <div className="text-xs uppercase tracking-[0.2em] text-muted-foreground">{label}</div>
      <Icon className="w-4 h-4 text-primary" />
    </div>
    <div className="font-serif-display text-3xl">{value}</div>
    {sub && <div className="text-xs text-muted-foreground mt-1">{sub}</div>}
  </div>
);

const Dashboard = () => {
  const [data, setData] = useState(null);
  useEffect(() => { api.get("/admin/dashboard").then(r => setData(r.data)); }, []);
  if (!data) return <div className="text-muted-foreground">Lade…</div>;

  return (
    <div className="space-y-6" data-testid="admin-dashboard">
      <div>
        <h1 className="font-serif-display text-3xl">Dashboard</h1>
        <p className="text-sm text-muted-foreground">Überblick KK Academy</p>
      </div>

      <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
        <Card icon={Users} label="Aktive Schüler" value={data.active_students} sub={`von ${data.total_students} total`} />
        <Card icon={Wallet} label="Offene Zahlungen" value={data.open_payments} />
        <Card icon={Calendar} label="Offene Abrechnungen" value={data.open_settlements} />
        <Card icon={TrendingUp} label="Brutto Monat" value={`CHF ${data.month.gross.toFixed(2)}`} sub={data.month.label} />
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
        <div className="card-academy rounded-lg p-6">
          <div className="text-xs uppercase tracking-[0.2em] text-primary mb-4">Monat {data.month.label}</div>
          <div className="space-y-2 text-sm">
            <div className="flex justify-between"><span className="text-muted-foreground">Brutto</span><span>CHF {data.month.gross.toFixed(2)}</span></div>
            <div className="flex justify-between"><span className="text-muted-foreground">Anteil Academy</span><span className="text-primary">CHF {data.month.academy.toFixed(2)}</span></div>
            <div className="flex justify-between"><span className="text-muted-foreground">Anteil Lehrer</span><span>CHF {data.month.teacher.toFixed(2)}</span></div>
          </div>
        </div>
        <div className="card-academy rounded-lg p-6">
          <div className="text-xs uppercase tracking-[0.2em] text-primary mb-4">Quartal {data.quarter.label}</div>
          <div className="space-y-2 text-sm">
            <div className="flex justify-between"><span className="text-muted-foreground">Brutto</span><span>CHF {data.quarter.gross.toFixed(2)}</span></div>
            <div className="flex justify-between"><span className="text-muted-foreground">Anteil Academy</span><span className="text-primary">CHF {data.quarter.academy.toFixed(2)}</span></div>
            <div className="flex justify-between"><span className="text-muted-foreground">Anteil Lehrer</span><span>CHF {data.quarter.teacher.toFixed(2)}</span></div>
          </div>
        </div>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
        <div className="card-academy rounded-lg p-6">
          <div className="text-xs uppercase tracking-[0.2em] text-primary mb-4">Nächste Workshops</div>
          <ul className="space-y-3 text-sm">
            {data.next_workshops.map(w => (
              <li key={w.id} className="flex justify-between border-b border-border pb-2"><span>{w.title}</span><span className="text-muted-foreground">{w.date}</span></li>
            ))}
            {data.next_workshops.length === 0 && <li className="text-muted-foreground">Keine</li>}
          </ul>
        </div>
        <div className="card-academy rounded-lg p-6">
          <div className="text-xs uppercase tracking-[0.2em] text-primary mb-4">Nächste Events</div>
          <ul className="space-y-3 text-sm">
            {data.next_events.map(e => (
              <li key={e.id} className="flex justify-between border-b border-border pb-2"><span>{e.title}</span><span className="text-muted-foreground">{e.date}</span></li>
            ))}
            {data.next_events.length === 0 && <li className="text-muted-foreground">Keine</li>}
          </ul>
        </div>
      </div>
    </div>
  );
};

export default Dashboard;
